import { type AnalyticsEventProperties, track as trackAnalyticsEvent } from '@cartwheel/analytics'
import { trackRumAction } from '@cartwheel/datadog'

/**
 * Declarative tracking for immediate component interactions.
 *
 * Track async success/failure, business outcomes, and compound interactions with multiple
 * activation paths explicitly in feature code so the event is emitted at the semantic boundary.
 */
export interface TrackConfig<TContext = void> {
  name: string
  properties?: AnalyticsEventProperties | ((context: TContext) => AnalyticsEventProperties)
}

/** Lowercases event name for RUM. Keep stable -- renames break saved RUM views. */
export const toRumActionName = (name: string): string =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '_')

export function trackInteraction<TContext>(
  config: TrackConfig<TContext> | undefined,
  context: TContext
) {
  if (!config) return

  const properties =
    typeof config.properties === 'function' ? config.properties(context) : config.properties

  trackAnalyticsEvent(config.name, properties)
  // Also emits RUM action. Declarative track prop only -- analytics.track() alone doesn't.
  trackRumAction(toRumActionName(config.name), properties)
}
